// src/hooks/useReprint.js
import { useState } from "react";
import api from "../services/api";

export function useReprint() {
  const [showReprintModal, setShowReprintModal] = useState(false);
  const [saleToReprint, setSaleToReprint] = useState(null);
  const [loadingReprint, setLoadingReprint] = useState(false);

  const handleOpenReprint = async (invoice) => {
    setLoadingReprint(true);
    try {
      const saleId = invoice.sale_id ?? invoice.sale?.id;
      const response = await api.get(`/sales/${saleId}/reprint`);
      setSaleToReprint(response.data);
      setShowReprintModal(true);
    } catch (error) {
      console.error("Error cargando datos para reimpresión:", error);
    } finally {
      setLoadingReprint(false);
    }
  };

  const handleCloseReprint = () => {
    setShowReprintModal(false);
    setSaleToReprint(null);
  };

  return {
    showReprintModal,
    saleToReprint,
    loadingReprint,
    handleOpenReprint,
    handleCloseReprint,
  };
}